import React, {  useReducer , useState} from 'react';

import RadioBox from '../components/radio-box';
import ButtonSection from '../components/button-section';
import logo from "../img/logo-bleu.webp";

const  months = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'aout',
    'septembre',
    'octobre',
    'novembre',
    'décembre'
];

const initListeEnfants = (enfants)=>{
    let listeEnfants = {};
    enfants.forEach( (enfant) => {
        listeEnfants[enfant]  =  { hasRessources:false } ;
    });
    return listeEnfants;
}

export default function QuestionRessourcesEnfants ( props ) {
    const [dataValid , setDataValid] = useState(true);
    const [errors , setErrors] = useState([]);
    const {step , restart , simulationData} = props;
    const reducer = (state, action) => {
        switch (action.type) {
        case 'update':
            return { ...state, [action.key]: action.value };
        default:
            return state;
        }
    };
    
    const [enfantsListe , dispatch] = useReducer( reducer , initListeEnfants(props.enfants));

    const getQuestionEnfant = (i)=>{
        const enfNum = (i+1) + ( i === 0  ? 'er' : 'eme');
        const date = new Date();
        const dateMonth =  `${months[date.getMonth()]} ${date.getFullYear() - 1 }`;
    
        return `Votre ${enfNum} enfant a-t-il perçu des ressources depuis ${dateMonth}`;
    };

    const handleSwitch = (value , enfant ) => {
        dispatch ( { 'type': 'update' , 'key':enfant , 'value': { hasRessources:JSON.parse(value) } });
    };

    const goToNextStep = ( )=>{
        const  listeEnfantsAyantRessources = props.enfants.filter( 
            (enfant)=>{
                return enfantsListe[enfant].hasRessources;
            }
        );
        props.nextStep(listeEnfantsAyantRessources);

    };

    return <div className="sim-form min-height">
        { Object.keys(enfantsListe).map( (enfant , id)=>{
            return <RadioBox
                name={enfant}
                model={enfantsListe[enfant].hasRessources}
                options={{"Oui" : true ,"Non" : false}}
                handler={handleSwitch}
                key={id}
            > { getQuestionEnfant(id)} </RadioBox>
        })}
        <ButtonSection
			restart={restart}
            action={goToNextStep}
            dataValid= {dataValid}
            data={simulationData}
            step={step}
            errors={errors}
        > 
        </ButtonSection>
            <div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
    </div>;
}